import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaChevronRight } from 'react-icons/fa';

const PageBreadcrumbs = ({ className = "" }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbNameMap = {
    'about': 'About Us',
    'services': 'Services',
    'orthotics': 'Orthotics',
    'Orthotics': 'Orthotics',
    'lunular-laser': 'Lunula Laser',
    'consultation-form': 'Book Consultation',
    'ConsultationForm': 'Book Consultation',
    'blog': 'Blog'
  };

  // Don't show breadcrumbs on homepage
  if (pathnames.length === 0) {
    return null;
  }

  return (
    <nav className={`text-xs text-gray-500 mb-6 ${className}`} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        <li>
          <Link 
            to="/" 
            className="flex items-center hover:text-secondary transition-colors"
            aria-label="Home"
          >
            <FaHome className="w-3 h-3" />
          </Link>
        </li>
        
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const displayName = breadcrumbNameMap[name] || name.charAt(0).toUpperCase() + name.slice(1);

          return (
            <li key={name} className="flex items-center">
              <FaChevronRight className="w-2 h-2 mx-1 text-gray-400" />
              {isLast ? (
                <span className="text-gray-700 font-medium" aria-current="page">
                  {displayName}
                </span>
              ) : (
                <Link 
                  to={routeTo} 
                  className="hover:text-secondary transition-colors"
                >
                  {displayName}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default PageBreadcrumbs; 